
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[tenant]/[store]/[[...pagepath]]",
      function () {
        return require("private-next-pages/[tenant]/[store]/[[...pagepath]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[tenant]/[store]/[[...pagepath]]"])
      });
    }
  